module.exports = __webpack_public_path__ + "static/img/xhj.1ba25e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xhj.jpg
// module id = ryxI
// module chunks = 1